<script lang="ts" setup>
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'
import { replaceImageSize } from '@autobid/ui/utils/car/generateImageSizes'

interface Props {
  title: string
  images: CarDetailsImage[]
}

defineProps<Props>()

const isPdfPage = inject('isPdfPage', false)
</script>

<template>
  <table class="w-full border-collapse" :class="{ 'mt-2': !isPdfPage }">
    <thead>
      <th
        colspan="2"
        class="text-left text-primary"
        :class="{ 'text-lg': !isPdfPage }"
      >
        {{ title }}:
      </th>
    </thead>
    <tbody>
      <tr
        v-for="image in images"
        :key="image.id"
        v-bind="
          isPdfPage
            ? { style: 'border-bottom: 1px solid #c1c1c1' }
            : { class: 'border-b border-[#c1c1c1]' }
        "
      >
        <td>
          <SectionsDetailsElementsImageLabel :image="image" />
        </td>
        <td
          class="td-image p-1"
          v-bind="isPdfPage ? { style: 'width:80px' } : undefined"
        >
          <img
            v-if="isPdfPage"
            :data-src="replaceImageSize(image.links.hd, 'hd', 'xs')"
            :alt="image.description.categoryLabel"
          >
          <SectionsDetailsElementsImage
            v-else
            :image="image"
            overlay-size="small"
            class="w-16"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>
